<xux-widget-boilerplate [field]="field" [attr.data-integration-id]="'input'">
    <input
      [ngStyle]="{
        'color': textColorObs | async,
        'background-color': backgroundColorObs | async
      }"
      [ngClass]="{ 'float-placeholder-control': field?.floatingPlaceholder, 'empty-control': !field?.control?.value}"
      #defaultFocusElement
      [type]="inputType"
      [formControl]="field?.control"
      [readonly]="field?.readonly"
      [placeholder]="field?.floatingPlaceholder ? '' : (placeholder$ | async)"
      [maxLength]="getMaxInputLength()"
      [mask]="field?.mask"
      [suffix]="maskPreferences?.suffix"
      [showMaskTyped]="maskPreferences?.showMaskTyped"
      [hiddenInput]="maskPreferences?.hiddenInput"
      [validation]="maskPreferences?.validation"
      [dropSpecialCharacters]="maskPreferences?.dropSpecialCharacters"
      [patterns]="maskPreferences?.customPatterns"
      (paste)="!field?.disabledInsertion"
      [attr.customScanning]="true"
    />
    <label
      *ngIf="field?.floatingPlaceholder"
      class="floating-placeholder {{field?.floatingPlaceholderPositionClass}}"
      >{{field?.floatingPlaceholder | translate}}</label
    >
  </xux-widget-boilerplate>
